
export enum ProcedureInstanceStateType {
    Processed = 0,
    PendingSign = 1,
    Error = 2,
    Enqueue = 3,
    Draft = 4
}
